<template>
  <el-dialog
    v-if="visible"
    append-to-body
    :title="title"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="800px"
  >
    <el-tabs v-model="activeName" @tab-click="handleClick" v-if="Object.keys(data).length > 1">
      <el-tab-pane v-for="item in data" :label="item.name" :name="item.label" :key="item.label"> </el-tab-pane>
    </el-tabs>
    <div>
      <!-- 下载导入模板 -->
      <section class="download-template">
        <div class="template-title">1. {{ item.download }}</div>
        <div class="template-tip">{{ item.tip }}</div>
        <div class="template-button">
          <el-button size="mini" class="el-icon-download" @click="handleExport()">{{ item.download_text }}</el-button>
        </div>
      </section>

      <!-- 上传完善后的表格 -->
      <section class="upload-template">
        <div class="template-title">2. {{ item.upload }}</div>
        <el-upload
          class="upload-demo"
          drag
          ref="upload"
          :data="formData"
          :action="uploadUrl"
          :file-format="fileFormat"
          :multiple="multiple"
          :headers="baseHeaders"
          :before-upload="beforeUploadHandle"
          :on-success="successHandle"
          :on-error="errorHandle"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            <em>{{ item.upload_text }}</em>
          </div>
          <div class="el-upload__tip" slot="tip">{{ item.upload_tip }}</div>
        </el-upload>
      </section>
      <section style="text-align: center; color: #409eff">
        <p v-if="item.uploadStatus">
          {{ $t('978') }}:
          <span v-if="item.type === '1'">
            {{
              $t('43', {
                x: item.uploadSuccessCount,
                y: item.update_count,
                z: item.uploadFailCount
              })
            }}
          </span>
          <span v-else>
            {{
              $t('update_result', {
                x: item.uploadSuccessCount,
                y: item.uploadFailCount
              })
            }}
          </span>
        </p>
        <p
          v-if="item.feedbackFileUrl"
          style="text-decoration: underline; margin-top: 10px; cursor: pointer"
          @click="handleOpenUrl(item.feedbackFileUrl)"
        >
          {{ $t('download_excel_result') }}
        </p>
      </section>
    </div>

    <!-- 确认取消 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" @click="doSubmit">{{ $t('67') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { baseHeaders } from 'util/axios-request'
import { utilCookies } from '@/util/cookies'
const baseURL = process.env.VUE_APP_BASE_API
export default {
  props: {
    subProjectId: String,
    fileSize: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      title: '',
      data: [],
      item: {},
      visible: false,
      activeName: '1',
      multiple: true,
      fileFormat: ['.xls', '.xlsx'],
      baseHeaders: baseHeaders(),
      // fileSize: 5,
      uploadHeaders: {},
      successFileList: [],
      uploadTotalCount: 0, // 总数
      uploadSuccessCount: 0, // 成功数
      uploadFailCount: 0, // 失败数
      update_count: 0,
      feedbackFileUrl: '',
      form: {
        name: ''
      },
      formData: {}
    }
  },
  computed: {
    uploadUrl() {
      return baseURL + this.item.upload_api
    }
  },
  methods: {
    init(data) {
      this.title = data.title
      this.data = data.list
      this.item = this.data[this.activeName]
      this.formData = this.item.query

      this.visible = true
    },
    handleClick() {
      this.item = this.data[this.activeName]
    },
    async handleExport() {
      // 模版下载
      const data = this.item || {}
      if (data.download_api) {
        data.download_api(data.query).then(res => {
          const url = res.data.url || res.data
          window.open(url)
        })
      } else {
        const lang = (utilCookies.getLanguage() && utilCookies.getLanguage().substring(0, 2)) || 'th'
        const res = data[lang] || ''
        window.open(res)
      }
    },
    beforeUploadHandle(file) {
      //  文件扩展名
      if (this.fileFormat.length) {
        const fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
        if (this.fileFormat.indexOf(fileExtend) <= -1) {
          this.$message.error(
            this.$t('729', {
              fileFormat: this.fileFormat.join()
            })
          )
          return false
        }
      } else {
        // this.listType = "text";
      }

      // 文件大小
      if (!(file.size / 1024 / 1024 < this.fileSize)) {
        this.$message.error(
          this.$t('730', {
            fileSize: this.fileSize
          })
        )
        return false
      }
    },
    // 上传成功+
    successHandle(res, file) {
      const data = res.data
      if (res && res.code === 1) {
        this.$set(this.item, 'uploadStatus', true)
        this.$set(this.item, 'uploadResultState', data.upload_result_state || 0) // 1.全部成功 3，全部失败，5部分成功
        this.$set(this.item, 'uploadSuccessCount', data.upload_success_count || 0) // 成功数
        this.$set(this.item, 'uploadFailCount', data.upload_fail_count || 0) // 失败数
        this.$set(this.item, 'update_count', data.upload_total_count || 0) // 覆盖数
        this.$set(this.item, 'uploadTotalCount', data.upload_total_count || 0) // 总数
        this.$set(this.item, 'feedbackFileUrl', data.file_path)
        if (data.list) this.$set(this.item, 'list', data.list || [])
        if (data.columns) this.$set(this.item, 'columns', data.columns || {})
        if (data.status_map) this.$set(this.item, 'status_map', data.status_map || [])
      }
    },
    doSubmit() {
      if (this.item.emit) {
        if (this.item.list) {
          this.$emit('doSubmit', {
            result_state: this.item.uploadResultState,
            list: this.item.list || [],
            status_map: this.item.status_map || [],
            columns: this.item.columns || {}
          })
        } else {
          this.$emit('doSubmit')
        }
      }
      this.visible = false
    },
    handleOpenUrl(url) {
      window.open(url)
    },
    // 上传失败
    // err, file, fileList
    errorHandle(err, file) {
      const index = this.$refs.upload.uploadFiles.findIndex(v => v.name === file.name)
      this.$refs.upload.uploadFiles.splice(index, 1)
      let msg = JSON.parse(err['message'])
      this.$message.error(msg.message)
      throw err
    },
    resetDate() {
      this.$set(this.item, 'uploadStatus', false)
      this.$set(this.item, 'uploadSuccessCount', 0) // 成功数
      this.$set(this.item, 'uploadFailCount', 0) // 失败数
      this.$set(this.item, 'update_count', 0) // 覆盖数
      this.$set(this.item, 'uploadTotalCount', 0) // 总数
      this.$set(this.item, 'feedbackFileUrl', '')
    },
    // 弹窗关闭时
    closeHandle() {
      this.reset()
      this.resetDate()
    },
    reset() {
      this.$refs.upload.clearFiles()
      this.successFileList = []
    }
  },
  watch: {
    successFileList: {
      handler(val) {
        if (val.length) this.$emit('uploadSuccess', val)
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 10px 20px 30px 20px;
}

.download-template {
  .template-tip {
    display: block;
    font-size: 12px;
    color: #8C8C8C;
    margin-top: 10px;
  }
  .template-button {
    margin-top: 10px;
  }
}

.upload-template {
  margin-top: 24px;
  .upload-demo {
    margin-top: 10px;
    ::v-deep .el-upload {
      display: block;
      .el-upload-dragger {
        width: 100%;
      }
    }
  }
  ::v-deep .el-upload__tip{
    margin-top: 10px;
  }
}


</style>
